import {post} from '@/utils/request';

// 新增数据
export function PermissionsAdd(Data) {
  return post('/Permissions/Add', Data); 
}
// 修改数据
export function PermissionsUpdate(Data) {
  return post('/Permissions/Update', Data); 
}
// 删除数据
export function PermissionsDel(Data) {
  return post('/Permissions/Del', Data); 
}
// 数据列表
export function PermissionsList(Data) {
  return post('/Permissions/List', Data); 
}

// 获取用户菜单列表
export function getList(Data) {
  return post('/RolePermissions/getList', Data); 
}


